import { render, staticRenderFns } from "./AuthStepBasic.vue?vue&type=template&id=40db0219"
import script from "./AuthStepBasic.vue?vue&type=script&lang=ts"
export * from "./AuthStepBasic.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40db0219')) {
      api.createRecord('40db0219', component.options)
    } else {
      api.reload('40db0219', component.options)
    }
    module.hot.accept("./AuthStepBasic.vue?vue&type=template&id=40db0219", function () {
      api.rerender('40db0219', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/upload_tabs/aws/AuthStepBasic.vue"
export default component.exports